import { gql } from "apollo-boost"

export const getSubmissions = gql`
  query getSubmissions ($where: DashboardSubmissionsWhere!){
    DashboardSubmissions (where: $where) {
      id
      name
      region
      concepts{
        region
      }
      approved
      beneficiaries {
        id
        number
      }
    }
  }
`
